import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {IEcommerceTaxSettingsEntityState} from "../reducers/ecommerce-tax-settings.reducer";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getEcommerceTaxSettingsState = (websiteId: number) =>
  createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.ecommerceTaxSettings.entities[websiteId]);

export const getEcommerceTaxSettings = (websiteId: number) => createSelector(getEcommerceTaxSettingsState(websiteId),
  (state: IEcommerceTaxSettingsEntityState) => {
    return state?.data ? state.data : [];
  }
);

export const getEcommerceTaxBasedOn = (websiteId: number) => createSelector(getEcommerceTaxSettingsState(websiteId),
    (state: IEcommerceTaxSettingsEntityState) => {
        return state?.data ? state.data.find(item => item.id === "woocommerce_tax_based_on") : [];
    }
);
export const getEcommercePricesIncludeTax = (websiteId: number) => createSelector(getEcommerceTaxSettingsState(websiteId),
    (state: IEcommerceTaxSettingsEntityState) => {
        return state?.data ? state.data.find(item => item.id === "woocommerce_prices_include_tax") : [];
    }
);
export const getEcommerceTaxShippingClass = (websiteId: number) => createSelector(getEcommerceTaxSettingsState(websiteId),
    (state: IEcommerceTaxSettingsEntityState) => {
        return state?.data ? state.data.find(item => item.id === "woocommerce_shipping_tax_class") : [];
    }
);
export const getEcommerceTaxTotalDisplay = (websiteId: number) => createSelector(getEcommerceTaxSettingsState(websiteId),
    (state: IEcommerceTaxSettingsEntityState) => {
        return state?.data ? state.data.find(item => item.id === "woocommerce_tax_total_display") : [];
    }
);
export const getEcommerceConnectTaxesEnabled = (websiteId: number) => createSelector(getEcommerceTaxSettingsState(websiteId),
    (state: IEcommerceTaxSettingsEntityState) => {
        return state?.data ? state.data.find(item => item.id === "wc_connect_taxes_enabled") : [];
    }
);

export const getEcommerceTaxSettingsLoading = (websiteId: number) => createSelector(getEcommerceTaxSettingsState(websiteId),
  (state: IEcommerceTaxSettingsEntityState) => state && state.loading
);

export const getEcommerceTaxSettingsLoaded = (websiteId: number) => createSelector(getEcommerceTaxSettingsState(websiteId),
  (state: IEcommerceTaxSettingsEntityState) => state && state.loaded
);
